var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFries({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8,86.5C73.8,86.5,73.8,86.5,73.8,86.5c-0.8,0-47.2,0-47.6,0c-0.8,0-1.4-0.6-1.5-1.4l-5-53.1c0-0.4,0.1-0.8,0.4-1.2   c0.3-0.3,0.7-0.5,1.1-0.5h10.2c0.8,0,1.5,0.7,1.5,1.5c0,4.6,1.8,8.8,5,12.1c0.1,0.1,0.3,0.3,0.4,0.4c2.1,1.9,4.6,3.3,7.3,4   c0,0,0,0,0.1,0c0,0,0,0,0,0c2.3,0.6,4.9,0.7,7.2,0.3c0.2,0,0.4-0.1,0.6-0.1c2.7-0.6,5.2-1.8,7.3-3.5c0.1-0.1,0.3-0.2,0.4-0.4   c3.7-3.3,5.8-8,5.8-12.9c0-0.8,0.7-1.5,1.5-1.5h10.2c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.7,0.4,1.2l-5,53.1   C75.2,85.9,74.6,86.5,73.8,86.5z M22.8,33.4l4.7,50.1c7,0,38,0,44.9,0l4.7-50.1H70c-0.4,5.2-2.8,10.1-6.8,13.6   c-0.1,0.1-0.3,0.3-0.5,0.4c-2.5,2-5.4,3.5-8.5,4.1c-0.2,0.1-0.5,0.1-0.8,0.2c-2.7,0.5-5.7,0.4-8.4-0.3c-0.1,0-0.2,0-0.3-0.1   c-3.1-0.9-6-2.5-8.4-4.7c-0.2-0.2-0.3-0.3-0.5-0.5c-3.4-3.4-5.4-7.9-5.8-12.7H22.8z M36.8,46.5c-0.4,0-0.8-0.2-1.1-0.4   c-3.4-3.4-5.4-7.9-5.8-12.7h-1c-0.8,0-1.5-0.7-1.5-1.5V15c0-0.8,0.7-1.5,1.5-1.5h7.9c0.8,0,1.5,0.7,1.5,1.5v30   c0,0.6-0.4,1.2-0.9,1.4C37.2,46.5,37,46.5,36.8,46.5z M30.4,30.4h1c0.8,0,1.5,0.7,1.5,1.5c0,3.1,0.8,6.1,2.4,8.8V16.5h-4.9V30.4z    M45.2,51.3c-0.1,0-0.3,0-0.4-0.1c-3.2-0.8-6.1-2.5-8.5-4.7c-0.3-0.3-0.5-0.7-0.5-1.1V24.4c0-0.8,0.7-1.5,1.5-1.5h7.9   c0.8,0,1.5,0.7,1.5,1.5v25.5c0,0.5-0.2,0.9-0.6,1.2C45.8,51.2,45.5,51.3,45.2,51.3z M38.8,44.8c1.5,1.3,3.1,2.3,4.9,3V25.9h-4.9   V44.8z M62.3,47.3c-0.2,0-0.4,0-0.6-0.1c-0.5-0.2-0.9-0.8-0.9-1.4V15c0-0.8,0.7-1.5,1.5-1.5h7.9c0.8,0,1.5,0.7,1.5,1.5v16.9   c0,0.8-0.7,1.5-1.5,1.5H70c-0.4,5.2-2.8,10.1-6.8,13.6C63,47.2,62.6,47.3,62.3,47.3z M63.8,16.5V42c2.1-2.9,3.3-6.5,3.3-10.1   c0-0.8,0.7-1.5,1.5-1.5h0.1V16.5H63.8z M53.9,51.6c-0.3,0-0.7-0.1-0.9-0.3c-0.4-0.3-0.6-0.7-0.6-1.2V24.4c0-0.8,0.7-1.5,1.5-1.5   h7.9c0.8,0,1.5,0.7,1.5,1.5v21.9c0,0.4-0.2,0.9-0.5,1.2c-2.5,2-5.4,3.5-8.5,4.1C54.1,51.6,54,51.6,53.9,51.6z M55.4,25.9v22.3   c1.8-0.6,3.4-1.5,4.9-2.6V25.9H55.4z M50,52c-1.7,0-3.5-0.2-5.1-0.7c-0.7-0.2-1.1-0.8-1.1-1.5V19.4c0-0.8,0.7-1.5,1.5-1.5h7.9   c0.8,0,1.5,0.7,1.5,1.5v30.9c0,0.7-0.5,1.4-1.2,1.5C52.3,51.9,51.2,52,50,52z M46.8,48.7c1.6,0.3,3.3,0.4,4.9,0.2V20.9h-4.9V48.7z    M49.8,79.1c-5.6,0-10.1-4.5-10.1-10.1s4.5-10.1,10.1-10.1S59.9,63.4,59.9,69S55.4,79.1,49.8,79.1z M49.8,61.9   c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1s7.1-3.2,7.1-7.1S53.7,61.9,49.8,61.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x37_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x38_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x39_"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_7"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_9"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_0"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_2"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_3"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFries);
export default __webpack_public_path__ + "static/media/fries.5c1ac33586a4d352f59ac7eedb730adf.svg";
export { ForwardRef as ReactComponent };